import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
import isEqual from 'lodash/isEqual';
import mixpanel from 'mixpanel-browser';

import { ACCESS_TOKEN } from 'src/constants';
import { IUserSettings } from 'src/recoil/selectors/permissionsSelector';

/* eslint-disable no-unused-vars */
export enum UserEvent {
  LogIn = 'Log In',
  LogOut = 'Log Out',
  NavAgentReports = 'Reporting - Open Agent Reports',
  NavAgentStatus = 'Reporting - Open Agent Status',
  NavAgentSummary = 'Reporting - Open Agent Summary',
  NavAuditTrail = 'Reporting - Open Audit Trail',
  NavBusinessReports = 'Reporting - Open Business Reports',
  NavBusinessSnapshots = 'Reporting - Open Business Snapshots',
  NavCallOutcomesReports = 'Reporting - Open Call Outcomes',
  NavInboundSummary = 'Reporting - Open Inbound Summary',
  NavQueuesReports = 'Reporting - Open Queues Reports',
  NavScheduledReports = 'Reporting - Open Scheduled Reports',
  NavSMSReports = 'Reporting - Open SMS Reports',
  NavTimeSaved = 'Reporting - Open Time Saved',
  NavTransferReports = 'Reporting - Open Transfer Reports',
  NavCallHistory = 'Reporting - Open Call History',
  NavSMSHistory = 'Reporting - Open SMS History',
  NavMyAgentSettings = 'My Profile - Open Agent Settings',
  NavMyInboundCallFlow = 'My Profile - Open Inbound Call Flow',
  NavMyPowerLists = 'My Profile - Open My PowerLists',
  NavMyPowerListContacts = 'My Profile - Open PowerList Contacts',
  NavMyNumbers = 'My Profile - Open Numbers',
  NavMySMSTemplates = 'My Profile - Open SMS Templates',
  NavMyVMDrop = 'My Profile - Open VM Drop',
  NavMyAgentSnapshot = 'My Profile - Open Agent Snapshot',
  NavMyCallHistory = 'My Profile - Open Call History',
  NavMyAgentSummary = 'My Profile - Open Agent Summary',
  NavMySMSHistory = 'My Profile - Open SMS History',
  Nav10DLC = 'Open 10DLC',
  NavAIInsights = 'Open AI Insights',
  NavAccountSettings = 'Manage - Open Account Settings',
  EditAccountSettings = 'Edit Account Settings',
  NavAgents = 'Open Agents',
  NavAutomations = 'Open Automations',
  NavCadences = 'Open Cadences',
  NavCompletedActions = 'Open Completed Actions',
  NavInflightActions = 'Open Inflight Actions',
  NavWebhooks = 'Open Webhooks',
  NavCallOutcomes = 'Open Call Outcomes',
  NavContacts = 'Open Contacts',
  NavConferences = 'Open Conferences',
  NavInboundRouting = 'Open Inbound Routing',
  NavIVRs = 'Open IVRs',
  NavQueues = 'Open Queues',
  NavRingGroups = 'Open Ring Groups',
  NavNumbersBlocked = 'Open Numbers Blocked',
  NavNumbers = 'Open Kixie Numbers',
  NavTeamSMS = 'Open Team SMS',
  NavPowerLists = 'Open PowerLists',
  NavPowerListContacts = 'Open PowerList Contacts',
  NavPowerListDispositions = 'Open Call Outcome Rules',
  NavTeams = 'Open Teams',
  NavLeaderboards = 'Open Leaderboards',
  NavLiveCallBoard = 'Open Live Call Board',
  NavQueuesLive = 'Open Queues Live',
  NavBillingHelp = 'Open Billing Help',
  NavInvoices = 'Open Invoices',
  NavSubscription = 'Open Subscription',
  NavUpdateCard = 'Open Update Card',
  NavSupportCenter = 'Open Support Center',
  NavInstallPowerCallDialer = 'Open Install PowerCall Dialer',
  NavOnboardingWalkthrough = 'Open Onboarding Walkthrough',
  SaveAddAgent = 'Save Add Agent',
  SaveCadence = 'Save Cadence',
  SearchMyNumbers = 'My Profile - Numbers - Search For Numbers',
  SaveAddBlockedNumber = 'Save Add Blocked Number',
  SaveAddCallOutcome = 'Save Add Call Outcome',
  SaveAddExternalNumber = 'Save Add External Number',
  SaveAddNumber = 'Save Add Number',
  SaveAddPort = 'Save Add Port',
  SaveAddSMSTemplate = 'Save Add SMS Template',
  SaveAddTeam = 'Save Add Team',
  SaveAddVMDrop = 'Save Add VM Drop',
  SaveAddLeaderboardSlide = 'Save Add Leaderboard Slide',
  SaveAddConference = 'Save Add Conference',
  SaveEditConference = 'Save Edit Conference',
  SaveInboundRouting = 'Save Inbound Routing',
  SavePersonalPowerList = 'Save Personal PowerList',
  SaveTeamPowerList = 'Save Team PowerList',
  SaveAdd10DLCCampaign = 'Save Add 10DLC Campaign',
  ToggledPowerListActive = 'Toggled PowerList Active',
  ClickedDuplicateHandling = 'Clicked PowerList Duplicate Handling',
  ToggledPreventDeselection = 'Toggled Prevent Deselection',
  ToggledRequireCallOutcome = 'Toggled Require Call Outcome',
  ToggledIgnoreDNC = 'Toggled Ignore DNC',
  ToggledAssignToAgentOnAnswer = 'Toggled Assign to Agent on Answer',
  ToggledOverrideOwnerOnAnswer = 'Toggled Override Owner on Answer',
  ToggledIfOwnedOnlyDialFromOwner = 'Toggled If Owned Only Dial From Owner',
  ClickedPowerListCallOutcomeDropdown = 'Clicked PowerList Call Outcome Dropdown',
  ClickedPowerListActionDropdown = 'Clicked PowerList Action Dropdown',
  AddPowerListCallOutcomeRule = 'Clicked Add PowerList Call Outcome Rule',
  DeletePowerListCallOutcomeRule = 'Clicked Delete PowerList Call Outcome Rule',
  AddPowerListTeam = 'Clicked Add Team to PowerList',
  ToggledPowerListUseBusinessHours = 'Toggled PowerList Use Business Hours',
  ClickedEditPowerListHours = 'Clicked Edit PowerList Hours',
  ToggledPowerListUseBusinessHoursForTarget = 'Toggled PowerList Use Business Hours for Target',
  ClickedEditTargetHours = 'Clicked Edit PowerList Target Hours',
  ClickedPowerListMaxAttemptsButton = 'Clicked PowerList Max Attempts Button',
  ClickedPowerListMinDurationDaysField = 'Clicked PowerList Min Duration Days Field',
  ClickedPowerListMinDurationHoursField = 'Clicked PowerList Min Duration Hours Field',
  ClickedPowerListMinDurationMinutesField = 'Clicked PowerList Min Duration Minutes Field',
  ClickedPowerListSecondsBeforeTimeoutDropdown = 'Clicked PowerList Seconds Before Timeout Dropdown',
  ClickedPowerListDialAtATimeDropdown = 'Clicked PowerList Dial At A Time Dropdown',
  ClickedPowerListNextPowerListDropdown = 'Clicked PowerList Next PowerList Dropdown',
  ClickedPowerListUploadContactsButton = 'Clicked PowerList Upload Contacts Button',
  SaveUpdateCard = 'Save Update Card',
  AddQueue = 'Add New Queue',
  SaveEditQueue = 'Save Edit Queue',
  SaveAddQueue = 'Save Add Queue',
  AddPersonalPowerList = 'Add Personal PowerList',
  AddSubscriptionMinutesSMSReserve = 'Add Subscription Minutes/SMS Reserve',
  ReSync10DLC = 'Re-Sync 10DLC',
  Add10DLCCampaign = 'Add 10DLC Campaign',
  EditManageProducts = 'Edit Manage Products',
  AddAgent = 'Add New Agent',
  AddCadence = 'Add New Cadence',
  AddConference = 'Add New Conference',
  AddCallOutcome = 'Add New Call Outcome',
  SyncCallOutcomes = 'Sync Call Outcomes',
  SyncCallOutcomesFromOutreach = 'Sync Call Outcomes From Outreach',
  AddIVR = 'Add New IVR',
  AddLeaderboardSlide = 'Add New Leaderboard Slide',
  AddBoostSetMGMT = 'Numbers - Add Boost Set MGMT',
  AddPort = 'Numbers -  Add Port',
  AddDirectoryExternalNumber = 'Numbers - Add Directory External Number',
  AddExternalNumber = 'Numbers - Add External Number',
  AddNumber = 'Numbers - Add New Number',
  AddTeamPowerList = 'Add New Team PowerList',
  EditPowerList = 'Edit PowerList',
  ClickedPowerListsPriorityTableHeader = 'Clicked PowerLists Priority Table Header',
  AddTeam = 'Add New Team',
  EditPowerListOnContacts = 'Edit PowerList on PowerLists Contacts',
  AddPowerListOnContacts = 'Add PowerList on PowerLists Contacts',
  RefreshPowerListContacts = 'Refresh PowerList Contacts',
  AddRingGroup = 'Add New Ring Group',
  SaveAddWebhook = 'Save Add Webhook',
  AddWebhook = 'Add New Webhook',
  AddBlockedNumber = 'Add Blocked Number',
  AddNewInboundRoutingRule = 'Add New Inbound Routing Rule',
  SaveIVR = 'Save IVR',
  AddPersonalNumber = 'Add Personal Number',
  RefreshQueuesLive = 'Refresh Queues Live',
  SaveRingGroup = 'Save Ring Group',
  AddMySMSTemplate = 'Add Personal SMS Template',
  AddMyVMDrop = 'Add Personal VM Drop',
  SaveAddTeamSMSRule = 'Save Add New Team SMS Rule',
  AddTeamSMS = 'Add New Team SMS',
  SaveEditAgent = 'Save Edit Agent',
  EditAgent = 'Edit Agent',
  EditNumber = 'Edit Number',
  EditSMSTemplate = 'Edit SMS Template',
  AddVMDrop = 'Add VM Drop',
  EditVMDrop = 'Edit VM Drop',
  SaveEditCallOutcome = 'Save Edit Call Outcome',
  EditCallOutcome = 'Edit Call Outcome',
  SaveEditViewTeam = 'Save Edit/View Team',
  EditViewTeam = 'Edit/View Team',
}

export function trackLogIn() {
  trackUserEvent(UserEvent.LogIn);
}
export function trackLogOut() {
  trackUserEvent(UserEvent.LogOut);
}
export function trackNavAgentReports() {
  trackUserEvent(UserEvent.NavAgentReports);
}
export function trackNavAgentStatus() {
  trackUserEvent(UserEvent.NavAgentStatus);
}
export function trackNavAgentSummary() {
  trackUserEvent(UserEvent.NavAgentSummary);
}
export function trackNavAuditTrail() {
  trackUserEvent(UserEvent.NavAuditTrail);
}
export function trackNavBusinessReports() {
  trackUserEvent(UserEvent.NavBusinessReports);
}
export function trackNavBusinessSnapshots() {
  trackUserEvent(UserEvent.NavBusinessSnapshots);
}
export function trackNavCallOutcomesReports() {
  trackUserEvent(UserEvent.NavCallOutcomes);
}
export function trackNavInboundSummary() {
  trackUserEvent(UserEvent.NavInboundSummary);
}
export function trackNavQueuesReports() {
  trackUserEvent(UserEvent.NavQueuesReports);
}
export function trackNavScheduledReports() {
  trackUserEvent(UserEvent.NavScheduledReports);
}
export function trackNavSMSReports() {
  trackUserEvent(UserEvent.NavSMSReports);
}
export function trackNavTimeSaved() {
  trackUserEvent(UserEvent.NavTimeSaved);
}
export function trackNavTransferReports() {
  trackUserEvent(UserEvent.NavTransferReports);
}
export function trackNavCallHistory() {
  trackUserEvent(UserEvent.NavCallHistory);
}
export function trackNavSMSHistory() {
  trackUserEvent(UserEvent.NavSMSHistory);
}
export function trackNavMyAgentSettings() {
  trackUserEvent(UserEvent.NavMyAgentSettings);
}
export function trackNavMyInboundCallFlow() {
  trackUserEvent(UserEvent.NavMyInboundCallFlow);
}
export function trackNavMyPowerLists() {
  trackUserEvent(UserEvent.NavMyPowerLists);
}
export function trackNavMyPowerListContacts() {
  trackUserEvent(UserEvent.NavMyPowerListContacts);
}
export function trackNavMyNumbers() {
  trackUserEvent(UserEvent.NavMyNumbers);
}
export function trackNavMySMSTemplates() {
  trackUserEvent(UserEvent.NavMySMSTemplates);
}
export function trackNavMyVMDrop() {
  trackUserEvent(UserEvent.NavMyVMDrop);
}
export function trackNavMyAgentSnapshot() {
  trackUserEvent(UserEvent.NavMyAgentSnapshot);
}
export function trackNavMyCallHistory() {
  trackUserEvent(UserEvent.NavMyCallHistory);
}
export function trackNavMyAgentSummary() {
  trackUserEvent(UserEvent.NavMyAgentSummary);
}
export function trackNavMySMSHistory() {
  trackUserEvent(UserEvent.NavMySMSHistory);
}
export function trackNav10DLC() {
  trackUserEvent(UserEvent.Nav10DLC);
}
export function trackNavAIInsights() {
  trackUserEvent(UserEvent.NavAIInsights);
}
export function trackNavAccountSettings() {
  trackUserEvent(UserEvent.NavAccountSettings);
}
export function trackEditAccountSettings() {
  trackUserEvent(UserEvent.EditAccountSettings);
}
export function trackNavAgents() {
  trackUserEvent(UserEvent.NavAgents);
}
export function trackNavAutomations() {
  trackUserEvent(UserEvent.NavAutomations);
}
export function trackNavCadences() {
  trackUserEvent(UserEvent.NavCadences);
}
export function trackNavCompletedActions() {
  trackUserEvent(UserEvent.NavCompletedActions);
}
export function trackNavInflightActions() {
  trackUserEvent(UserEvent.NavInflightActions);
}
export function trackNavWebhooks() {
  trackUserEvent(UserEvent.NavWebhooks);
}
export function trackNavCallOutcomes() {
  trackUserEvent(UserEvent.NavCallOutcomes);
}
export function trackNavContacts() {
  trackUserEvent(UserEvent.NavContacts);
}
export function trackNavConferences() {
  trackUserEvent(UserEvent.NavConferences);
}
export function trackNavInboundRouting() {
  trackUserEvent(UserEvent.NavInboundRouting);
}
export function trackNavIVRs() {
  trackUserEvent(UserEvent.NavIVRs);
}
export function trackNavQueues() {
  trackUserEvent(UserEvent.NavQueues);
}
export function trackNavRingGroups() {
  trackUserEvent(UserEvent.NavRingGroups);
}
export function trackNavTeamSMS() {
  trackUserEvent(UserEvent.NavTeamSMS);
}
export function trackNavPowerLists() {
  trackUserEvent(UserEvent.NavPowerLists);
}
export function trackPowerListContacts() {
  trackUserEvent(UserEvent.NavPowerListContacts);
}
export function trackPowerListDispositions() {
  trackUserEvent(UserEvent.NavPowerListDispositions);
}
export function trackNavTeams() {
  trackUserEvent(UserEvent.NavTeams);
}
export function trackNavLeaderboards() {
  trackUserEvent(UserEvent.NavLeaderboards);
}
export function trackNavLiveCallBoard() {
  trackUserEvent(UserEvent.NavLiveCallBoard);
}
export function trackNavQueuesLive() {
  trackUserEvent(UserEvent.NavQueuesLive);
}
export function trackNavBillingHelp() {
  trackUserEvent(UserEvent.NavBillingHelp);
}
export function trackNavInvoices() {
  trackUserEvent(UserEvent.NavInvoices);
}
export function trackNavSubscription() {
  trackUserEvent(UserEvent.NavSubscription);
}
export function trackNavUpdateCard() {
  trackUserEvent(UserEvent.NavUpdateCard);
}
export function trackNavSupportCenter() {
  trackUserEvent(UserEvent.NavSupportCenter);
}
export function trackNavInstallPowerCallDialer() {
  trackUserEvent(UserEvent.NavInstallPowerCallDialer);
}
export function trackNavOnboardingWalkthrough() {
  trackUserEvent(UserEvent.NavOnboardingWalkthrough);
}
export function trackSearchMyNumbers() {
  trackUserEvent(UserEvent.SearchMyNumbers);
}
export function trackSaveAddAgent() {
  trackUserEvent(UserEvent.SaveAddAgent);
}
export function trackSaveAddBlockedNumber() {
  trackUserEvent(UserEvent.SaveAddBlockedNumber);
}
export function trackSaveAddCallOutcome() {
  trackUserEvent(UserEvent.SaveAddCallOutcome);
}
export function trackSaveAddExternalNumber() {
  trackUserEvent(UserEvent.SaveAddExternalNumber);
}
export function trackSaveAddNumber() {
  trackUserEvent(UserEvent.SaveAddNumber);
}
export function trackSaveAddPort() {
  trackUserEvent(UserEvent.SaveAddPort);
}
export function trackSaveAddSMSTemplate() {
  trackUserEvent(UserEvent.SaveAddSMSTemplate);
}
export function trackSaveAddTeam() {
  trackUserEvent(UserEvent.SaveAddTeam);
}
export function trackSaveAddVMDrop() {
  trackUserEvent(UserEvent.SaveAddVMDrop);
}
export function trackSaveAddLeaderboardSlide() {
  trackUserEvent(UserEvent.SaveAddLeaderboardSlide);
}
export function trackSaveAddConference() {
  trackUserEvent(UserEvent.SaveAddConference);
}
export function trackSaveEditConference() {
  trackUserEvent(UserEvent.SaveEditConference);
}
export function trackSaveInboundRouting() {
  trackUserEvent(UserEvent.SaveInboundRouting);
}
export function trackSaveCadence() {
  trackUserEvent(UserEvent.SaveCadence);
}
export function trackSavePersonalPowerList() {
  trackUserEvent(UserEvent.SavePersonalPowerList);
}
export function trackSaveTeamPowerList() {
  trackUserEvent(UserEvent.SaveTeamPowerList);
}
export function trackSaveAdd10DLCCampaign() {
  trackUserEvent(UserEvent.SaveAdd10DLCCampaign);
}
export function trackToggledPowerListActive() {
  trackUserEvent(UserEvent.ToggledPowerListActive);
}
export function trackClickedDuplicateHandling() {
  trackUserEvent(UserEvent.ClickedDuplicateHandling);
}
export function trackToggledPreventDeselection() {
  trackUserEvent(UserEvent.ToggledPreventDeselection);
}
export function trackToggledRequireCallOutcome() {
  trackUserEvent(UserEvent.ToggledRequireCallOutcome);
}
export function trackToggledIgnoreDNC() {
  trackUserEvent(UserEvent.ToggledIgnoreDNC);
}
export function trackToggledAssignToAgentOnAnswer() {
  trackUserEvent(UserEvent.ToggledAssignToAgentOnAnswer);
}
export function trackToggledOverrideOwnerOnAnswer() {
  trackUserEvent(UserEvent.ToggledOverrideOwnerOnAnswer);
}
export function trackToggledIfOwnedOnlyDialFromOwner() {
  trackUserEvent(UserEvent.ToggledIfOwnedOnlyDialFromOwner);
}
export function trackClickedPowerListCallOutcomeDropdown() {
  trackUserEvent(UserEvent.ClickedPowerListCallOutcomeDropdown);
}
export function trackClickedPowerListActionDropdown() {
  trackUserEvent(UserEvent.ClickedPowerListActionDropdown);
}
export function trackAddPowerListCallOutcomeRule() {
  trackUserEvent(UserEvent.AddPowerListCallOutcomeRule);
}
export function trackDeletePowerListCallOutcomeRule() {
  trackUserEvent(UserEvent.DeletePowerListCallOutcomeRule);
}
export function trackAddPowerListTeam() {
  trackUserEvent(UserEvent.AddPowerListTeam);
}
export function trackToggledPowerListUseBusinessHours() {
  trackUserEvent(UserEvent.ToggledPowerListUseBusinessHours);
}
export function trackClickedEditPowerListHours() {
  trackUserEvent(UserEvent.ClickedEditPowerListHours);
}
export function trackToggledPowerListUseBusinessHoursForTarget() {
  trackUserEvent(UserEvent.ToggledPowerListUseBusinessHoursForTarget);
}
export function trackClickedEditTargetHours() {
  trackUserEvent(UserEvent.ClickedEditTargetHours);
}
export function trackClickedPowerListMaxAttemptsButton() {
  trackUserEvent(UserEvent.ClickedPowerListMaxAttemptsButton);
}
export function trackClickedPowerListMinDurationDaysField() {
  trackUserEvent(UserEvent.ClickedPowerListMinDurationDaysField);
}
export function trackClickedPowerListMinDurationHoursField() {
  trackUserEvent(UserEvent.ClickedPowerListMinDurationDaysField);
}
export function trackClickedPowerListMinDurationMinutesField() {
  trackUserEvent(UserEvent.ClickedPowerListMinDurationMinutesField);
}
export function trackClickedPowerListSecondsBeforeTimeoutDropdown() {
  trackUserEvent(UserEvent.ClickedPowerListSecondsBeforeTimeoutDropdown);
}
export function trackClickedPowerListDialAtATimeDropdown() {
  trackUserEvent(UserEvent.ClickedPowerListDialAtATimeDropdown);
}
export function trackClickedPowerListNextPowerListDropdown() {
  trackUserEvent(UserEvent.ClickedPowerListNextPowerListDropdown);
}
export function trackClickedPowerListUploadContactsButton() {
  trackUserEvent(UserEvent.ClickedPowerListUploadContactsButton);
}
export function trackSaveUpdateCard() {
  trackUserEvent(UserEvent.SaveUpdateCard);
}
export function trackAddQueue() {
  trackUserEvent(UserEvent.AddQueue);
}
export function trackSaveEditQueue() {
  trackUserEvent(UserEvent.SaveEditQueue);
}
export function trackSaveAddQueue() {
  trackUserEvent(UserEvent.SaveAddQueue);
}
export function trackAddPersonalPowerList() {
  trackUserEvent(UserEvent.AddPersonalPowerList);
}
export function trackAddSubscriptionMinutesSMSReserve() {
  trackUserEvent(UserEvent.AddSubscriptionMinutesSMSReserve);
}
export function trackReSync10DLC() {
  trackUserEvent(UserEvent.ReSync10DLC);
}
export function trackAdd10DLCCampaign() {
  trackUserEvent(UserEvent.Add10DLCCampaign);
}
export function trackEditManageProducts() {
  trackUserEvent(UserEvent.EditManageProducts);
}
export function trackAddAgent() {
  trackUserEvent(UserEvent.AddAgent);
}
export function trackAddCadence() {
  trackUserEvent(UserEvent.AddCadence);
}
export function trackAddConference() {
  trackUserEvent(UserEvent.AddConference);
}
export function trackAddCallOutcome() {
  trackUserEvent(UserEvent.AddCallOutcome);
}
export function trackSyncCallOutcomes() {
  trackUserEvent(UserEvent.SyncCallOutcomes);
}
export function trackSyncCallOutcomesFromOutreach() {
  trackUserEvent(UserEvent.SyncCallOutcomesFromOutreach);
}
export function trackAddIVR() {
  trackUserEvent(UserEvent.AddIVR);
}
export function trackAddLeaderboardSlide() {
  trackUserEvent(UserEvent.AddLeaderboardSlide);
}
export function trackAddBoostSetMGMT() {
  trackUserEvent(UserEvent.AddBoostSetMGMT);
}
export function trackAddPort() {
  trackUserEvent(UserEvent.AddPort);
}
export function trackAddDirectoryExternalNumber() {
  trackUserEvent(UserEvent.AddDirectoryExternalNumber);
}
export function trackAddExternalNumber() {
  trackUserEvent(UserEvent.AddExternalNumber);
}
export function trackAddNumber() {
  trackUserEvent(UserEvent.AddNumber);
}
export function trackAddTeamPowerList() {
  trackUserEvent(UserEvent.AddTeamPowerList);
}
export function trackEditPowerList() {
  trackUserEvent(UserEvent.EditPowerList);
}
export function trackClickedPowerListsPriorityTableHeader() {
  trackUserEvent(UserEvent.ClickedPowerListsPriorityTableHeader);
}
export function trackAddTeam() {
  trackUserEvent(UserEvent.AddTeam);
}
export function trackEditPowerListOnContacts() {
  trackUserEvent(UserEvent.EditPowerListOnContacts);
}
export function trackAddPowerListOnContacts() {
  trackUserEvent(UserEvent.AddPowerListOnContacts);
}
export function trackRefreshPowerListContacts() {
  trackUserEvent(UserEvent.RefreshPowerListContacts);
}
export function trackAddRingGroup() {
  trackUserEvent(UserEvent.AddRingGroup);
}
export function trackSaveAddWebhook() {
  trackUserEvent(UserEvent.SaveAddWebhook);
}
export function trackAddWebhook() {
  trackUserEvent(UserEvent.AddWebhook);
}
export function trackAddBlockedNumber() {
  trackUserEvent(UserEvent.AddBlockedNumber);
}
export function trackAddNewInboundRoutingRule() {
  trackUserEvent(UserEvent.AddNewInboundRoutingRule);
}
export function trackSaveIVR() {
  trackUserEvent(UserEvent.SaveIVR);
}
export function trackAddPersonalNumber() {
  trackUserEvent(UserEvent.AddPersonalNumber);
}
export function trackRefreshQueuesLive() {
  trackUserEvent(UserEvent.RefreshQueuesLive);
}
export function trackSaveRingGroup() {
  trackUserEvent(UserEvent.SaveRingGroup);
}
export function trackAddMySMSTemplate() {
  trackUserEvent(UserEvent.AddMySMSTemplate);
}
export function trackAddMyVMDrop() {
  trackUserEvent(UserEvent.AddMyVMDrop);
}
export function trackSaveAddTeamSMSRule() {
  trackUserEvent(UserEvent.SaveAddTeamSMSRule);
}
export function trackAddTeamSMS() {
  trackUserEvent(UserEvent.AddTeamSMS);
}
export function trackNavNumbersBlocked() {
  trackUserEvent(UserEvent.NavNumbersBlocked);
}
export function trackNavNumbers() {
  trackUserEvent(UserEvent.NavNumbers);
}
export function trackSaveEditAgent() {
  trackUserEvent(UserEvent.SaveEditAgent);
}
export function trackEditAgent() {
  trackUserEvent(UserEvent.EditAgent);
}
export function trackEditNumber() {
  trackUserEvent(UserEvent.EditNumber);
}
export function trackEditSMSTemplate() {
  trackUserEvent(UserEvent.EditSMSTemplate);
}
export function trackAddVMDrop() {
  trackUserEvent(UserEvent.AddVMDrop);
}
export function trackEditVMDrop() {
  trackUserEvent(UserEvent.EditVMDrop);
}
export function trackSaveEditCallOutcome() {
  trackUserEvent(UserEvent.SaveEditCallOutcome);
}
export function trackEditCallOutcome() {
  trackUserEvent(UserEvent.EditCallOutcome);
}
export function trackSaveEditViewTeam() {
  trackUserEvent(UserEvent.SaveEditViewTeam);
}
export function trackEditViewTeam() {
  trackUserEvent(UserEvent.EditViewTeam);
}

// guard to prevent mixpanel from being used without initialization
let mixPanelInitialized = false;

// List of business IDs excluded from mixpanel tracking
const EXCLUDED_BUSINESS_IDS = [
  995,
  21594,
  30251,
  41994,
  42086,
  42102,
  44559,
  47887,
  51452,
  51453,
  51454,
  51455,
  51456,
];

/**
 * Checks if a business ID is excluded from mixpanel tracking
 * @param businessId The business ID to check
 * @returns true if the business ID is excluded
 */
const isExcludedBusiness = (businessId?: number): boolean => {
  if (!businessId) return false;
  return EXCLUDED_BUSINESS_IDS.includes(businessId);
};

export const isMixPanelFeatureFlagged = () => {
  return (
    (process.env.VITE_APP_ENV === 'prod' ||
      process.env.VITE_APP_ENV === 'qa') &&
    Number(process.env.VITE_APP_MIXPANEL_FEATURED) === 1
  );
};

/**
 * Use mix panel if production and kixie business
 * NOTE: access token used since hooks cannot be used
 * @returns true if MixPanel is enabled
 */
export const isMixPanelEnabled = () => {
  try {
    const accessToken = Cookies.get(ACCESS_TOKEN);
    const userSettings: IUserSettings | null = accessToken
      ? jwt_decode(accessToken)
      : null;
    return (
      mixPanelInitialized &&
      isMixPanelFeatureFlagged() &&
      !isExcludedBusiness(userSettings?.businessId)
    );
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.error('userTracking.ts: unable to decode access token', exception);
    return false;
  }
};

/**
 * Tracks updates by comparing current values with initial values and sending a tracking event.
 *
 * @param {object} values - The current state of values.
 * @param {object} initialValues - The initial state of values for comparison.
 * @param {string} eventName - The name of the tracking event.
 * @param {string} activeTab - The active tab name (optional).
 */
export function trackModalUpdates(
  values,
  initialValues,
  eventName,
  activeTab = ''
) {
  // Ensure the keys match
  const validKeys = Object.keys(initialValues);
  const changedFields = validKeys.reduce((acc, key) => {
    const currentValue = values[key];
    const initialValue = initialValues[key];

    // Ensure both are objects before further processing
    if (
      !currentValue ||
      !initialValue ||
      typeof currentValue !== 'object' ||
      typeof initialValue !== 'object'
    ) {
      return acc; // Skip keys where either value is undefined/null
    }

    if (!isEqual(currentValue, initialValue)) {
      // Extract only the keys that changed
      const changedKeys = Object.keys(currentValue).filter(
        (currentKey) =>
          Object.prototype.hasOwnProperty.call(initialValue, currentKey) && // Fix applied here
          !isEqual(currentValue[currentKey], initialValue[currentKey])
      );

      if (changedKeys.length > 0) {
        acc[key] = [...changedKeys]; // Ensure only the names are stored
      }
    }

    return acc;
  }, {});

  // Track the event using mixpanel
  if (isMixPanelEnabled()) {
    try {
      mixpanel.track(eventName, {
        changedFields,
        activeTab,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        'userTracking.ts: unable to track modal updates',
        eventName,
        error
      );
    }
  }
}

function trackUserEvent(userEvent: UserEvent): void {
  if (isMixPanelEnabled()) {
    try {
      mixpanel.track(userEvent);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        'userTracking.ts: unable to track user event',
        userEvent,
        error
      );
    }
  }
}

function mixpanelCreateUser(userSettings: IUserSettings | undefined) {
  return {
    $name: [userSettings?.name, userSettings?.lname].filter(Boolean).join(' '),
    $email: userSettings?.email,
    userid: userSettings?.userid,
    businessId: userSettings?.businessId,
    role: userSettings?.role,
    inTrial: userSettings?.inTrial,
  };
}

export function mixpanelRegisterUser(userSettings?: IUserSettings | undefined) {
  if (isMixPanelEnabled() && userSettings) {
    // Add Global/Super Properties to Mixpanel events
    try {
      mixpanel.register(mixpanelCreateUser(userSettings));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('userTracking.ts: unable to register mixpanel user', error);
    }
  }
}

export function mixpanelSetUser(userSettings?: IUserSettings | undefined) {
  const userId = userSettings?.userid?.toString?.();
  if (isMixPanelEnabled() && userId) {
    try {
      mixpanel.identify(userId);
      mixpanel.people.set(mixpanelCreateUser(userSettings));

      // Track an event after identify to trigger identity merge
      // This merges the anonymous $device_id with the authenticated $user_id
      mixpanel.track('User Identified', {
        source: 'mixpanelSetUser',
        businessid: userSettings?.businessId,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('userTracking.ts: unable to set mixpanel user', error);
    }
  }
}

export function mixpanelReset() {
  if (isMixPanelEnabled()) {
    try {
      mixpanel.reset();
    } catch (exception) {
      // eslint-disable-next-line no-console
      console.error('userTracking.ts: unable to reset Mixpanel', exception);
    }
  }
}

export async function initializeMixpanel() {
  // access token is not set when this is called therefore must be always on
  if (isMixPanelFeatureFlagged()) {
    mixPanelInitialized = true;
    try {
      await mixpanel.init(process.env.VITE_APP_MIXPANEL_TOKEN || '', {
        debug: true,
        track_pageview: 'url-with-path',
        persistence: 'localStorage',
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('userTracking.ts: unable to initialize mixpanel', error);
    }
  }
}
